/*
 * Public API Surface of dp-world-sidebar
 */

// export * from './lib/dp-world-sidebar.service';
export * from './lib/dp-world-sidebar.component';
export * from './lib/dp-world-sidebar.module';
